import { alpha, createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';

const contentShadowHeight = 83;

export const styles = ({ palette, spacing, zIndex }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      position: 'relative',
    },
    workspaces: {
      backgroundColor: '#201E42', // TODO: Change after palette updated
      borderRight: `1px solid ${alpha(colours.solid.white, 0.2)}`, // TODO: Change after palette updated
      height: '100%',
      padding: spacing(4, 3),
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
    },
    navigation: {
      backgroundColor: '#201E42', // TODO: Change after palette updated
      color: 'white', // TODO remove after content implementation
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',

      '&:hover': {
        '& $collapseBtn': {
          opacity: 1,
        },
      },
    },
    navigationCollapsed: {
      position: 'relative',

      '& $collapseBtn': {
        paddingLeft: spacing(3.5),
      },

      '& $sideNavigationInvite': {
        display: 'none',
      },

      '&::after': {
        content: '""',
        position: 'absolute',
        backgroundColor: '#201E42', // TODO: Change after palette updated
        height: '100%',
        bottom: 0,
        left: 0,
        top: 0,
        right: 0,
      },
    },

    impersonateContainer: {},
    impersonateTooltip: {
      backgroundColor: colors.black.darker,
      fontSize: 13,
      marginTop: spacing(3),
      padding: spacing(5, 4),
      textAlign: 'center',
    },
    impersonateTooltipArrow: {
      fontSize: 13,
      top: `0 !important`,

      '&::before': {
        backgroundColor: colors.black.darker,
        border: `2px solid ${colors.black.darker}`,
      },
    },
    impersonateLink: {
      backgroundImage: `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAGCAIAAAAOtlpdAAAANElEQVQoz2P4etGEEnRxi0lHFdXQ8slQYxkGoZsochbt3ES+s2jqJjKdRWs3keMsOrgJiAB4ItlirqqJGgAAAABJRU5ErkJggg==) !important`,
      backgroundPosition: '-8px 0',
      backgroundRepeat: 'repeat-x',
      backgroundSize: '25px 7px',
      display: 'block',
      flex: '0 0 auto',
      height: 7,
    },
    impersonateLinkProduction: {
      backgroundImage: 'none !important',
      background: '#FF0000', // Simple red background
    },
    sideNavigationInvite: {
      margin: spacing(3),
    },
    inviteAction: {
      backgroundColor: colours.brandTeal[100],
      border: 'none',
      color: colours.brandTeal[700],
      width: '100%',
      padding: spacing(2, 2.5),

      '&:hover': {
        backgroundColor: colours.brandTeal[200],
        color: colours.brandTeal[700],
      },
    },
    inviteActionLabel: {
      justifyContent: 'flex-start',
    },
    inviteIcon: {
      fontSize: '20px !important',
      color: colours.brandTeal[700],
    },
    header: {
      flex: '0 0 auto',
      overflow: 'hidden',
      padding: spacing(4, 3, 4, 5),
      width: '100%',
    },
    upgradeCta: {
      marginTop: spacing(4),
    },
    contentContainer: {
      flex: '1 1 auto',
      width: '100%',
      overflow: 'hidden',

      position: 'relative',

      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        left: 10,
        opacity: 0,
        pointerEvents: 'none',
        right: 10,
      },

      '&::after': {
        content: '""',
        position: 'absolute',
        background: 'linear-gradient(359deg, #201E42 11.15%, rgba(32, 30, 66, 0.00) 88.15%)',
        height: contentShadowHeight,
        bottom: 0,
        opacity: 1,
      },
    },
    content: {
      height: '100%',
      overflowY: 'auto',
      padding: spacing(2, 3, 4, 3),
      paddingBottom: contentShadowHeight,
    },
    collapseBtn: {
      border: `1px solid #D1D6DF`, // TODO: Change after palette updated
      borderRadius: 6,
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.07)',
      opacity: 0,
      position: 'absolute',
      right: -13,
      top: 32,
      transition: 'background-color 0.3s ease, border 0.3s ease',
      paddingLeft: spacing(3.75),
      width: 24,
      zIndex: zIndex.drawer,

      '& svg path': {
        stroke: '#7E8899', // TODO: Change after palette updated
      },

      '&:hover': {
        backgroundColor: `${palette.primarySpecial.main} !important`,
        borderColor: palette.primarySpecial.main,

        '& svg path': {
          stroke: `${colors.white.lightest} !important`,
        },
      },
    },
    collapseBtnVisible: {
      opacity: 1,
    },
    collapseLine: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: -12,
      width: 24,
      backgroundColor: 'transparent',
      cursor: 'ew-resize',
    },
    marketplaceSectionContainer: {
      margin: spacing(4, 2.5),
      height: 1,
      maxWidth: '100%',
      backgroundColor: alpha(colors.white.lightest, 0.25),
    },
    marketplaceSectionLabel: {
      fontSize: 12,
      fontWeight: 600,
      color: colors.white.lightest,
      padding: spacing(0, 2.5, 2),
      userSelect: 'none',
    },
    footer: {
      flex: '0 0 auto',
      padding: spacing(0, 3, 4),
    },
    footerDivider: {
      height: 1,
      marginBottom: spacing(4),
      maxWidth: '100%',
      backgroundColor: alpha(colors.white.lightest, 0.25),
    },
    hiddenContent: {
      visibility: 'hidden',
    },

    //Styles below only for overriding default styles for landlord app
    katoLogo: {},
    sideNavigationItemTitle: {},
    sideNavigationItemIcon: {},
    sideNavigationItemLink: {},
    sideNavigationItemLinkActive: {},
    sideNavigationItemGroupStartIcon: {},
    sideNavigationItemGroupLink: {},
    sideNavigationItemGroupLinkDotContainer: {},
    sideNavigationItemGroupLinkDot: {},
    sideNavigationItemGroupToggleIcon: {},
    sideNavigationItemGroupToggleButton: {},
    landlordNavigation: {
      background: colors.kato.neutral[50],

      '& $footerDivider': {
        background: colors.kato.neutral[200],
      },

      '&::after': {
        background: colors.kato.neutral[50],
      },

      '& $katoLogo path': {
        fill: colors.kato.brandNavy[900],
      },

      '& $contentContainer': {
        '&::after': {
          background: 'transparent',
        },
      },

      '& $sideNavigationItemTitle': {
        color: colors.kato.neutral[600],
      },

      '& $sideNavigationItemIcon': {
        stroke: colors.kato.neutral[500],
      },

      '& $sideNavigationItemLink': {
        stroke: colors.kato.neutral[500],

        '&:hover': {
          background: colors.kato.neutral[200],
        },
      },
      '& $sideNavigationItemLinkActive': {
        background: colors.kato.neutral[200],

        '& $sideNavigationItemTitle': {
          color: colors.kato.neutral[900],
        },
      },

      '& $sideNavigationItemGroupToggleButton': {
        stroke: colors.kato.neutral[500],

        '&:hover': {
          background: colors.kato.neutral[200],
          stroke: colors.kato.neutral[500],

          '& $sideNavigationItemGroupStartIcon': {
            '& svg ': {
              stroke: colors.kato.neutral[500],
            },
          },
          '& $sideNavigationItemGroupToggleIcon': {
            '& path': {
              stroke: alpha(colors.kato.neutral[500], 0.65),
            },
          },
        },
      },

      '& $sideNavigationItemGroupStartIcon': {
        '& svg ': {
          stroke: colors.kato.neutral[500],
        },
      },
      '& $sideNavigationItemGroupToggleIcon': {
        '& path': {
          stroke: alpha(colors.kato.neutral[500], 0.65),
        },
      },

      '& $sideNavigationItemGroupLink': {
        '&:hover': {
          background: colors.kato.neutral[200],
          '& $sideNavigationItemGroupLinkDot': {
            background: colors.kato.neutral[500],
          },
        },
      },

      '& $sideNavigationItemGroupLinkDot': {
        background: colors.kato.neutral[300],
      },
      '& $sideNavigationItemGroupLinkDotContainer': {
        '&::after': {
          background: colors.kato.neutral[300],
        },
      },
    },
  });
